// import { useState } from "react";
// import { addData, getData } from "../utils/localCrud";
// import "./CreateUser.css";

// export default function CreateUser() {
//     const [name, setName] = useState("");
//     const [email, setEmail] = useState("");
//     const [phone, setPhone] = useState("");
//     const [role, setRole] = useState("user");
//     const [loading, setLoading] = useState(false);
//     const [message, setMessage] = useState("");

//     const handleAdd = () => {
//         if (!name || !email) {
//             setMessage("Please enter name and email");
//             return;
//         }

//         const users = getData("users");
//         const emailExists = users.some(user => user.email === email);

//         if (emailExists) {
//             setMessage("Email already exists!");
//             return;
//         }

//         setLoading(true);
//         setMessage("");

//         addData("users", {
//             id: Date.now(),
//             name,
//             email,
//             phone,
//             role,
//             createdAt: new Date().toISOString()
//         });

//         setTimeout(() => {
//             setMessage("User added successfully!");
//             setName("");
//             setEmail("");
//             setPhone("");
//             setRole("user");
//             setLoading(false);

//             // Clear message after 3 seconds
//             setTimeout(() => setMessage(""), 3000);
//         }, 800);
//     };

//     return (
//         <div className="create-user">
//             <h2><span></span> Create New User</h2>

//             {message && (
//                 <div className={`alert ${message.includes("successfully") ? "alert-success" : "alert-error"}`}>
//                     {message}
//                 </div>
//             )}

//             <div className="form">
//                 <div className="form-group">
//                     <label>Full Name *</label>
//                     <input
//                         type="text"
//                         placeholder="Enter full name"
//                         value={name}
//                         onChange={e => setName(e.target.value)}
//                     />
//                 </div>

//                 <div className="form-group">
//                     <label>Email Address *</label>
//                     <input
//                         type="email"
//                         placeholder="Enter email address"
//                         value={email}
//                         onChange={e => setEmail(e.target.value)}
//                     />
//                 </div>

//                 <div className="form-group">
//                     <label>Phone Number</label>
//                     <input
//                         type="tel"
//                         placeholder="Enter phone number"
//                         value={phone}
//                         onChange={e => setPhone(e.target.value)}
//                     />
//                 </div>

//                 <div className="form-group">
//                     <label>Role</label>
//                     <select value={role} onChange={e => setRole(e.target.value)}>
//                         <option value="user">User</option>
//                         <option value="admin">Admin</option>
//                         <option value="moderator">Moderator</option>
//                     </select>
//                 </div>

//                 <button
//                     className="btn-primary"
//                     onClick={handleAdd}
//                     disabled={loading}
//                 >
//                     {loading ? "Creating..." : "Create User"}
//                 </button>
//             </div>
//         </div>
//     );
// }
import { useState } from "react";
import "./CreateUser.css";

export default function CreateUser() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [role, setRole] = useState("Admin");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // success | error

    const handleAdd = async () => {
  // ✅ Frontend validation
  if (!name.trim() || !email.trim() || !password || !confirmPassword) {
    setMessage("Please fill all required fields");
    setMessageType("error");
    return;
  }

  if (password !== confirmPassword) {
    setMessage("Passwords do not match");
    setMessageType("error");
    return;
  }

  setLoading(true);
  setMessage("");

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/User.php`, // remove /auth/
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          mobile: phone.trim(),
          password,
          role,
          status: "Active"
        })
      }
    );

    const data = await response.json();

    if (response.ok && data.success === true) {
      setMessage(data.message || "User added successfully!");
      setMessageType("success");

      // ✅ Reset form
      setName("");
      setEmail("");
      setPhone("");
      setPassword("");
      setConfirmPassword("");
      setRole("Admin");
    } else {
      setMessage(data.message || "Failed to create user");
      setMessageType("error");
    }

  } catch (error) {
    console.error(error);
    setMessage("Server error. Please try again later.");
    setMessageType("error");
  } finally {
    setLoading(false);
    setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, 3000);
  }
};


    return (
        <div className="create-user">
            <h2>Create New User</h2>

            {message && (
                <div className={`alert ${messageType === "success" ? "alert-success" : "alert-error"}`}>
                    {message}
                </div>
            )}

            <div className="form">
                <input
                    type="text"
                    placeholder="Full Name *"
                    value={name}
                    onChange={e => setName(e.target.value)}
                />

                <input
                    type="email"
                    placeholder="Email *"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />

                <input
                    type="tel"
                    placeholder="Mobile"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Password *"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Confirm Password *"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                />

                <select value={role} onChange={e => setRole(e.target.value)}>
                    <option value="Admin">Admin</option>
                    <option value="User">User</option>
                    <option value="Moderator">Moderator</option>
                </select>

                <button onClick={handleAdd} disabled={loading}>
                    {loading ? "Creating..." : "Create User"}
                </button>
            </div>
        </div>
    );
}
